import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-tai-chi-yoga': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_summary_checkpoints_tai_chi_male~1
			funnel: {
				id: 'ob-male-tai-chi-yoga-summary-checkpoints',
				locale: ['en'],
			},
		},
	},
]

export default config
